<template>
  <button class="w-6 h-6 rounded flex justify-center items-center transform transition hover:bg-gray-100 hover:rotate-180"
          v-tooltip="$t('common.reset')"
          @click="$emit('click')"
  >
    <img class="w-4 h-4"
         src="@/assets/images/reset.svg"
         alt="reset"
    >
  </button>
</template>

<script>
export default {
  name: 'GrmResetBtn',
  props: {
    notShowTooltip: { type: Boolean, default: false },
    color: { type: String, default: 'black' },
  },
  computed: {
    fillColor() {
      switch (this.color) {
        case 'white': return '#fff';
        case 'black': return '#000';
        case 'info': return '#1d4ed8';
        case 'success': return '#15803d';
        case 'warning': return '#a16207';
        case 'error': return '#b91c1c';
        default : return '#000';
      }
    }
  }
}
</script>